import React from "react";
import {
  Box,
  TextField,
  InputAdornment,
  Paper,
  Typography,
} from "@mui/material";
import {
  X as XIcon,
  Facebook as FacebookIcon,
  Instagram as InstagramIcon,
  LinkedIn as LinkedInIcon,
} from "@mui/icons-material";

const SocialMediaInput = ({ onChange, values = {} }) => {
  const socialPlatforms = [
    {
      key: "x",
      label: "X (Twitter)",
      icon: <XIcon />,
      placeholder: "https://twitter.com/username",
    },
    {
      key: "fb",
      label: "Facebook",
      icon: <FacebookIcon />,
      placeholder: "https://facebook.com/username",
    },
    {
      key: "in",
      label: "Instagram",
      icon: <InstagramIcon />,
      placeholder: "https://instagram.com/username",
    },
    {
      key: "ln",
      label: "LinkedIn",
      icon: <LinkedInIcon />,
      placeholder: "https://linkedin.com/in/username",
    },
  ];

  const handleChange = (platformKey, value) => {
    const updatedValues = {
      ...values,
      [platformKey]: value,
    };

    // Ensure all keys are present in the object (even if empty)
    socialPlatforms.forEach((platform) => {
      if (!(platform.key in updatedValues)) {
        updatedValues[platform.key] = "";
      }
    });

    if (onChange) {
      onChange(updatedValues);
    }
  };

  return (
    <Paper elevation={1} sx={{ p: 3, width: "100%" }}>
      <Typography variant="h6" gutterBottom sx={{ mb: 2 }}>
        Social Media Links
      </Typography>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
        {socialPlatforms.map((platform) => (
          <TextField
            key={platform.key}
            fullWidth
            label={platform.label}
            value={values[platform.key] || ""}
            onChange={(e) => handleChange(platform.key, e.target.value)}
            placeholder={platform.placeholder}
            InputProps={{
              startAdornment: (
                <InputAdornment
                  position="start"
                  sx={{ color: "text.secondary" }}
                >
                  {platform.icon}
                </InputAdornment>
              ),
            }}
            variant="outlined"
            size="small"
          />
        ))}
      </Box>
    </Paper>
  );
};

export default SocialMediaInput;
